import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Wrap ResizeObserver callbacks to avoid the common dev-time loop warning
// triggered by carousel/layout libraries under rapid reflows.
if (typeof window !== "undefined" && "ResizeObserver" in window) {
  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// Ignore the noisy ResizeObserver browser warning triggered by slider/layout libraries.
const resizeObserverError = "ResizeObserver loop completed with undelivered notifications.";
const resizeObserverAltError = "ResizeObserver loop limit exceeded";

const isResizeObserverLoopError = (value = "") =>
  typeof value === "string" &&
  (value.includes(resizeObserverError) || value.includes(resizeObserverAltError));

const originalConsoleError = window.console.error;
window.console.error = (...args) => {
  if (args.some((arg) => isResizeObserverLoopError(arg?.message || arg))) {
    return;
  }

  originalConsoleError(...args);
};

window.onerror = (message) => {
  if (isResizeObserverLoopError(message)) {
    return true;
  }

  return false;
};

window.addEventListener("error", (event) => {
  if (
    isResizeObserverLoopError(event.message) ||
    isResizeObserverLoopError(event.error?.message)
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener("unhandledrejection", (event) => {
  if (
    isResizeObserverLoopError(event.reason?.message) ||
    isResizeObserverLoopError(event.reason)
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
